import { useEffect } from "react"

import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import { setOpenConversations } from "../redux/messaging.slice.ts"

/**
 * Publish which conversations this screen is showing.
 *
 * The socket lives once, in `MessagingController`; a screen says what it has
 * open so that one socket can have the server confirm those conversations, and
 * clears the list on unmount so a closed screen stops claiming them.
 */
export const useOpenConversations = (ids: Array<string | null | undefined>) => {
  const dispatch = useAppDispatch()
  const key = ids.filter(Boolean).join(",")

  useEffect(() => {
    dispatch(setOpenConversations(key ? key.split(",") : []))
    return () => {
      dispatch(setOpenConversations([]))
    }
  }, [key, dispatch])
}
